import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import axios from 'axios';
import moment from 'moment';
// material
import { styled } from '@mui/material/styles';
import {
  Card,
  Table,
  Stack,
  Button,
  CircularProgress,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Icon,
  Container,
  TableContainer,
  TablePagination,
  OutlinedInput,
  InputAdornment,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { ContentCopy, CopyAll, Edit, Person } from '@mui/icons-material';
import CopyToClipboard from 'react-copy-to-clipboard';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import AddIcon from '@mui/icons-material/Add';
import ModeEditSharpIcon from '@mui/icons-material/ModeEditSharp';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Filter from './filters/Bill';

// components
import Scrollbar from './Scrollbar';
import Iconify from './Iconify';
// import Popup from './popups/BillStatusChange';

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

/// custom tablecell with custom padding
const TableCellCustom = styled(TableCell)(({ theme }) => ({
  padding: '14px 8px',
}));

function ProjectBillTable({ status, customerId, customer, projectId, quotationId }) {
  const navigate = useNavigate();
  const [billData, setBillData] = useState();
  const [name, setName] = useState('');
  const [pages, setPages] = useState(0);
  const [billCount, setBillCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [size, setSize] = useState(10);
  const [options, setOptions] = useState({ size, page: 0, isPaymentCompleted: status === 'completed' });

  const handlePageChange = (event, newPage) => {
    const temp = { ...options, page: newPage };
    setPages(newPage);
    setOptions(temp);
    setIsLoading(true);
    getBills(temp);
  };

  const getBills = (options) => {
    const temp = { ...options, customerId, projectId, quotationId };
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/billing/all`, {
        params: temp,
      })
      .then((res) => {
        console.log('res', res);
        if (res.data.isError === false) {
          setIsLoading(false);
          setBillCount(res.data.data.maxRecords);
          setBillData(res.data.data.records);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const getBillsWithoutLoading = (options) => {
    const temp = { ...options, customerId, projectId, quotationId };
    axios
      .get(`${process.env.REACT_APP_API_URL}/billing/all`, {
        params: temp,
      })
      .then((res) => {
        console.log('res', res);
        if (res.data.isError === false) {
          setBillCount(res.data.data.maxRecords);
          setBillData(res.data.data.records);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const onSearch = (e) => {
    e.preventDefault();
    setName(e.target.value);
    const temp = { ...options, page: 0, customerName: e.target.value };
    setOptions(temp);
    setPages(0);
    getBillsWithoutLoading(temp);
  };

  const applyFilters = (filter) => {
    console.log('filter', filter);
    setName('');
    const temp = { page: 0, size };

    if (filter._id) {
      temp._id = filter._id;
    }
    if (filter.isPaymentCompleted.length) {
      temp.isPaymentCompleted = filter.isPaymentCompleted.trim();
    }
    if (filter.invoiceNumber) {
      temp.invoiceNumber = filter.invoiceNumber;
    }
    if (filter.customerId) {
      temp.customerId = filter.customerId;
    }
    if (filter.startDate) {
      temp.startDate = filter.startDate;
    }
    if (filter.endDate) {
      temp.endDate = filter.endDate;
    }
    if (filter.txnId) {
      temp.txnId = filter.txnId;
    }
    if (filter.phone) {
      temp.phone = filter.phone;
    }
    if (filter.email) {
      temp.email = filter.email;
    }

    setOptions(temp);
    setPages(0);
    getBills(temp);
  };
  useEffect(() => {
    getBills(options);
  }, [quotationId, customerId, projectId, status]);

  useEffect(() => {
    const temp = { ...options, size, page: 0 };
    setPages(0);
    setOptions(temp);
    getBills(temp);
  }, [size]);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <Filter applyFilters={applyFilters} customerId={customerId} projectId={projectId} filterValues={options} />
          <Stack direction="row" justifyContent={customerId || projectId ? 'end' : 'space-between'} alignItems="center">
            {!customerId && !projectId && (
              <Stack direction="row" spacing={2} padding={2}>
                <SearchStyle
                  value={name}
                  onChange={onSearch}
                  placeholder="Search Customer name..."
                  startAdornment={
                    <InputAdornment position="start">
                      <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                    </InputAdornment>
                  }
                />
              </Stack>
            )}
            <Stack padding={1} direction="row" justifyContent="flex-end" spacing={2} alignItems="center">
              {status !== 'completed' && (
                <Button
                  startIcon={<AddIcon />}
                  variant="contained"
                  onClick={() =>
                    navigate(`/dashboard/accounts/bill/add-bill?projectId=${projectId}`, { state: customer || null })
                  }
                >
                  Invoice
                </Button>
              )}
            </Stack>
          </Stack>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCellCustom>Sl No</TableCellCustom>
                    <TableCellCustom>Invoice Date</TableCellCustom>
                    <TableCellCustom>Invoice Number</TableCellCustom>
                    <TableCellCustom>Quotatin ID</TableCellCustom>
                    <TableCellCustom>Grand Total</TableCellCustom>
                    {status === 'pending' && <TableCellCustom>Paid </TableCellCustom>}
                    {status === 'pending' && <TableCellCustom>Pending </TableCellCustom>}
                    <TableCellCustom>View</TableCellCustom>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {billData?.map((item, id) => (
                    <TableRow key={id} sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}>
                      <TableCellCustom>{pages * size + (id + 1)}</TableCellCustom>
                      <TableCellCustom>{moment(item?.invoiceDate).format('DD-MM-YYYY')}</TableCellCustom>
                      <TableCellCustom style={{ cursor: 'pointer' }}>
                        <Stack direction="column" spacing={0.5}>
                          <CopyToClipboard text={item.invoiceNumber} onCopy={() => toast.info('Invoice Number copied')}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={0.5}
                              sx={{ cursor: 'pointer' }}
                              justifyContent="flex-start"
                            >
                              <ContentCopy color="primary" />
                              <Typography variant="p">{item.invoiceNumber}</Typography>
                            </Stack>
                          </CopyToClipboard>
                        </Stack>
                      </TableCellCustom>
                      <TableCellCustom style={{ cursor: 'pointer' }}>
                        <Stack direction="column" spacing={0.5}>
                          <CopyToClipboard
                            text={item?.quotationData?.quotationId}
                            onCopy={() => toast.info('Quotation ID copied')}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={0.5}
                              sx={{ cursor: 'pointer' }}
                              justifyContent="flex-start"
                            >
                              <ContentCopy color="primary" />
                              <Typography variant="p">{item?.quotationData?.quotationId}</Typography>
                            </Stack>
                          </CopyToClipboard>
                        </Stack>
                      </TableCellCustom>

                      <TableCellCustom>{item.grandTotal}</TableCellCustom>
                      {status === 'pending' && <TableCellCustom>{item.paidAmount}</TableCellCustom>}
                      {status === 'pending' && <TableCellCustom>{item?.pendingAmount?.toFixed(2)}</TableCellCustom>}
                      <TableCellCustom>
                        <Box>
                          <Link to={`/dashboard/accounts/bill/view-bill?id=${item.invoiceNumber}`}>
                            <Icon sx={{ color: 'gray' }}>
                              <RemoveRedEyeIcon />
                            </Icon>
                          </Link>
                        </Box>
                      </TableCellCustom>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            onRowsPerPageChange={(e) => {
              setSize(e.target.value);
            }}
            component={'div'}
            count={billCount}
            showFirstButton
            showLastButton
            onPageChange={handlePageChange}
            rowsPerPage={size}
            page={pages}
          />
        </>
      )}
    </>
  );
}

export default ProjectBillTable;
